import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const DataTableCol = ({ className, width, wrapperEl, wrapperClassName, children }) => {
  const compClassName = classnames(className,
    {
      datatable__col: !width,
      [`datatable__col-${width}`]: width
    }
  )

  function renderCell () {
    return (wrapperEl) ? React.createElement(wrapperEl, { className: wrapperClassName }, children) : children
  }

  return (
    <div className={compClassName}>{renderCell()}</div>
  )
}

DataTableCol.defaultProps = {
  wrapperEl: 'p'
}

DataTableCol.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  wrapperEl: PropTypes.string,
  wrapperClassName: PropTypes.string,
  children: PropTypes.node
}

export default DataTableCol
